// pull in config vars
import * as config from "./config"
import getJamFilledCookie from "./getJamFilledCookie"
import fetch from "isomorphic-fetch"
import getUserIdFromLocalStorage from "./getUserIdFromLocalStorage"

interface Members {
	// TODO: What is the shape of the returned JSON?
}

export default async function getPeopleInTheJam(
	JAM_ID: string,
): Promise<Members | false> {
	try {
		const res = await fetch(
			`${config.API_HOSTNAME}/api/plugin/jam/${JAM_ID}/members`,
			{
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"jam-filled-cookie": getJamFilledCookie(),
					"jam-filled-userid": getUserIdFromLocalStorage(),
				},
			},
		)

		const json = await res.json()

		// returns updated thread object
		return json.members
	} catch (e) {
		return false
	}
}

// const mentions = [
//   {
//     name: 'irtefa',
//     avatar: 'https://d1qb2nb5cznatu.cloudfront.net/users/872577-large?1516836931',
//   },
//   {
//     name: 'dani',
//     avatar: 'https://www.usv.com/wp-content/uploads/2019/05/danigrant-1.jpeg',
//   }
// ];

// export default mentions;
